import { Text } from '@wix/design-system';
import * as React from 'react';
import css from './RecurringPayView.scss';
import { WithTranslation, withTranslation } from 'react-i18next';
import { InvoicePayData } from '../InvoicePayMainSection/InvoicePayMainSection';

interface RecurringPayViewProps extends WithTranslation {
  invoice: InvoicePayData;
  currency: any;
}

const enum BillingCycle {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
  FORTNIGHTLY = 'fortnightly',
}
export const frequencyTranslations = {
  [BillingCycle.DAILY]: 'invoice.recurring.email.billing-frequency.daily',
  [BillingCycle.WEEKLY]: 'invoice.recurring.email.billing-frequency.weekly',
  [BillingCycle.FORTNIGHTLY]:
    'invoice.recurring.email.billing-frequency.fortnightly',
  [BillingCycle.MONTHLY]: 'invoice.recurring.email.billing-frequency.monthly',
  [BillingCycle.YEARLY]: 'invoice.recurring.email.billing-frequency.yearly',
};

const RecurringPayViewComp: React.FunctionComponent<RecurringPayViewProps> = ({
  t,
  invoice,
  currency,
}) => {
  const {
    total,
    metaData: {
      sourceProperties: { billingCycle, numberOfBillingCycles, frequency },
    },
  } = invoice;
  const isUnlimitedBilling = numberOfBillingCycles === '0';

  return (
    <div data-hook="recurring-pay-view" className={css.container}>
      <Text weight="bold">
        {`${t('recurring-payment-uou.title')} `}
        {isUnlimitedBilling
          ? t('recurring-payment-uou.title.unlimited', { billingCycle })
          : t('recurring-payment-uou.title.limited', {
              billingCycle,
              numberOfBillingCycles,
            })}
        <br />
      </Text>
      <Text size="small">
        {t('invoice.recurring.pay.view.text', {
          total: currency(total),
          // @ts-expect-error
          frequency: t(frequencyTranslations[frequency.toLocaleLowerCase()]),
        })}
      </Text>
    </div>
  );
};
export const RecurringPayView = withTranslation()(RecurringPayViewComp);
